import { useMemo } from "react";
import { useParams } from "react-router";
import { useCampaign } from "src/hooks/campaigns";
import { mapCampaign } from "src/utils/mapping/mapToInput";

import { CampaignInquiryDuplicationTemplate } from "./CampaignInquiryDuplicationTemplate";

const CampaignInquiryDuplicationCampaignPage = () => {
    const { campaignId } = useParams();
    const { campaign, isLoadingCampaign } = useCampaign(campaignId);

    const initialValues = useMemo(() => {
        return campaign ? mapCampaign(campaign) : undefined;
    }, [campaign]);

    return (
        <CampaignInquiryDuplicationTemplate
            key={campaign?.id}
            initialValues={initialValues}
            draftIntent={`copy:${campaignId}`}
            isLoading={isLoadingCampaign}
        />
    );
};

export default CampaignInquiryDuplicationCampaignPage;
